import React from 'react'
import { useForm } from 'react-hook-form'

import { Input } from '../../components/forms/Input'
import TagManager from '../../lib/tag-manager'

type ContactFormProps = {
    issue: string
    lastCID: string
    registeredPhoneNumber: string
    contractNumber: string
    operationTime: string
}

const ContactPage: React.FC = () => {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        clearErrors,
    } = useForm<ContactFormProps>()

    const handleOnCancel = () => {
        clearErrors()
    }

    const onSubmitPostMessage = async (data: ContactFormProps) => {
        const isInClient = window.liff.isInClient()
        const profile = await window.liff.getProfile()

        TagManager.clickEvent({
            page: 'contact-page',
            action: 'click',
            field: JSON.stringify({ isInClient, uid: profile.userId, ...data }),
        })
        if (isInClient) {
            let text = `1.${data.issue}\n2.เลขบัตรประชาชน 5 หลักสุดท้าย: ${data.lastCID}\n3.เบอร์โทรศัพท์ที่ลงทะเบียนไว้: ${data.registeredPhoneNumber}\n4.เลขที่คำขอสินเชื่อ/สัญญา (ถ้ามี): ${data.contractNumber}`
            if (data.operationTime) {
                text = text.concat(`\n5.เวลาที่ต้องการติดต่อเจ้าหน้าที่: ${data.operationTime} น.`)
            }
            try {
                await window.liff.sendMessages([
                    {
                        type: 'text',
                        text,
                    },
                ])
                TagManager.popupEvent({
                    page: 'contact-page',
                    action: 'send-message',
                    field: JSON.stringify({
                        isInClient,
                        uid: profile.userId,
                        ...data,
                        status: 'success',
                    }),
                })
            } catch (e) {
                TagManager.popupEvent({
                    page: 'contact-page',
                    action: 'send-message',
                    field: JSON.stringify({
                        isInClient,
                        uid: profile.userId,
                        ...data,
                        status: 'failure',
                        errorCode: e.code,
                        message: e.message,
                    }),
                })
            }
            window.liff.closeWindow()
        }
    }

    return (
        <div className="abcs-container">
            <h1 className="text-xl font-semibold py-4">โปรดกรอกข้อมูลเพื่อติดต่อเจ้าหน้าที่</h1>
            <form
                onSubmit={handleSubmit(onSubmitPostMessage)}
                className="grid grid-flow-row gap-y-4"
            >
                <Input
                    required
                    title="คำถามหรือปัญหาสอบถาม"
                    type="text"
                    id="issue"
                    className="font-sans"
                    errors={errors}
                    {...register('issue', { required: true })}
                />
                <Input
                    required
                    title="เลขประจำตัวประชาชน 5 หลักสุดท้าย"
                    type="text"
                    pattern="[0-9]*"
                    maxLength={5}
                    inputMode="numeric"
                    id="lastCID"
                    errors={errors}
                    {...register('lastCID', {
                        minLength: 5,
                        required: true,
                    })}
                />
                <Input
                    required
                    title="เบอร์โทรศัพท์ที่ลงทะเบียนไว้"
                    type="text"
                    pattern="[0-9]*"
                    maxLength={10}
                    inputMode="numeric"
                    id="registeredPhoneNumber"
                    errors={errors}
                    {...register('registeredPhoneNumber', {
                        minLength: 10,
                        pattern: /^0\d{8,9}$/gim,
                        required: true,
                    })}
                />
                <Input
                    title="เลขที่คำขอ/สัญญาสินเชื่อ (ถ้ามี)"
                    type="text"
                    pattern="[0-9]*"
                    inputMode="numeric"
                    id="contractNumber"
                    errors={errors}
                    {...register('contractNumber')}
                />

                {/* {shownContactTime && (
                    <div>
                        <label className="block" htmlFor="operationTime">
                            เวลาที่ต้องการติดต่อเจ้าหน้าที่
                        </label>
                        <select
                            name="operationTime"
                            className="p-2 bg-white border border-gray-500 rounded w-full"
                            id="operationTime"
                            ref={register}
                        >
                            <OptionOperationTimes
                                range={range}
                                excludedHour={{ started: 12, duration: 1 }}
                            />
                        </select>
                    </div>
                )} */}

                <div className="grid grid-cols-2 gap-x-4">
                    <button
                        onClick={handleOnCancel}
                        type="button"
                        className="p-3 border border-gray-700 rounded"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="p-3 border border-blue-500 bg-blue-500 text-white rounded"
                        disabled={isSubmitting}
                    >
                        Confirm
                    </button>
                </div>
            </form>
        </div>
    )
}

export default ContactPage
